import { Box, Container, Typography } from "@mui/material";
import tiendaDigitalIcon from "../assets/images/tienda_digital.svg";
import colores from "../shared/constant/styles";
interface ITitle {
  title: string;
}

export default function Title(props: ITitle) {
  return (
    <div
      className="container-fluid"
      style={{
        width: "100%",
        overflow: "hidden",
        clear: "both",
        marginBottom: "1.85rem",
        padding: "1vh",
      }}
    >
      <Container style={{ paddingRight: "20px", paddingLeft: "20px" }}>
        <div className="d-flex justify-content-between flex-wrap align-items-center ">
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <img
              src={tiendaDigitalIcon}
              alt="Tienda Digital"
              style={{ width: 50, height: 50 }}
            />
          </Box>

          <Typography
            sx={{
              color: colores.title,
              mt: 1,
              mb: 3,
              fontWeight: 520,
              fontSize: 26,
              fontFamily: "Stag",
            }}
          >
            {props.title}
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              color: colores.grisClaro,
              fontWeight: 200,
              fontSize: 13,
              marginTop: -3,
              fontFamily: "Stag",
            }}
          >
            Confirmá tu compra de forma rápida y segura
          </Typography>
        </div>
      </Container>
    </div>
  );
}
